import { useQuery } from "@tanstack/react-query";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { isAdminRole } from "@/auth/shared";
import { title } from "@/components/base/primitives";
import { migrationStatsQueryOptions } from "@/functions/admin/migration-stats";
import { DefaultLayout } from "@/layouts/default";

export const Route = createFileRoute("/admin/")({
  loader: async ({ context }) => {
    const viewer = context.viewer;

    if (!viewer || !isAdminRole(viewer.role)) {
      throw redirect({ to: "/not-found" });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { data: stats } = useQuery(migrationStatsQueryOptions());

  return (
    <DefaultLayout
      classNames={{
        content: "flex flex-col space-y-12 max-w-2xl px-3 py-12 mx-auto",
      }}
    >
      <h1 className={title({ size: "lg" })}>Dashboard</h1>

      <div className="grid grid-cols-3 gap-4">
        <StatCard label="Migrated Users" value={stats?.migratedUsers ?? "—"} />
        <StatCard label="Total Users" value={stats?.totalUsers ?? "—"} />
        <StatCard
          label="Active Memberships"
          value={stats?.activeMemberships ?? "—"}
        />
        <StatCard
          label="Upcoming Tournaments"
          value={stats?.upcomingTournaments ?? "—"}
        />
        <StatCard
          label="Upcoming Registrations"
          value={stats?.upcomingRegistrations ?? "—"}
        />
        <StatCard label="Profile Photos" value={stats?.profilePhotos ?? "—"} />
      </div>
    </DefaultLayout>
  );
}

function StatCard({ label, value }: { label: string; value: string | number }) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4">
      <div className="text-sm text-gray-500">{label}</div>
      <div className="text-2xl font-semibold">{value}</div>
    </div>
  );
}
